/*import { GanttWorkItem } from "../../types/gantt";
import { leftPx, widthPx } from "../../utils/ganttUtils";


function formatDate(value: string) {
  const d = new Date(value);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}`;
}

export function ForecastBar({
  item,
  timelineStart,
  pxPerDay,
  timelineWidth,
}: {
  item: GanttWorkItem;
  timelineStart: Date;
  pxPerDay: number;
  timelineWidth: number;
}) {
  if (!item.forecast) return null;

  const start = new Date(item.forecast.start);
  const end = new Date(item.forecast.end);

  const left = leftPx(start, timelineStart, pxPerDay);
  const width = Math.max(widthPx(start, end, pxPerDay), 8);

  const startLabel = formatDate(item.forecast.start);
  const endLabel = formatDate(item.forecast.end);

  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  const durationDays =
    Math.ceil((end.getTime() - start.getTime()) / MS_PER_DAY) + 1;

  // gray start date - 45 days
  const grayMinus45 = new Date(start.getTime() - 45 * MS_PER_DAY);

  // actual end date < gray start date - 45 days
  const actualEnd = item.actual?.end ? new Date(item.actual.end) : null;
  const showOutsideRight = actualEnd ? actualEnd < grayMinus45 : false;

  // inside labels only when bar is long AND not the outside-right case
  const showInsideLabels = durationDays > 45 && !showOutsideRight;

  const isPositiveWorkId = item.workId > 0;

  const barClass = isPositiveWorkId
    ? "absolute top-[28px] h-3 border border-gray-700 border-dashed bg-gray-600 group z-30"
    : "absolute top-[28px] h-3 border border-gray-400 border-dashed bg-gray-400 group z-30";

  const labelStyle: React.CSSProperties = {
    fontFamily: "Segoe UI, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    textShadow: "0 0 2px white",
  };

  return (
    <div className={barClass} style={{ left, width }}>
    
      <div className="pointer-events-none absolute -top-14 left-1/2 -translate-x-1/2 z-50 hidden group-hover:block">
        <div className="rounded bg-gray-900 text-white text-xs px-3 py-2 shadow-lg whitespace-nowrap">
          <div>
            <span className="font-semibold">Work:</span> {item.workElement}
          </div>
          <div>
            <span className="font-semibold">Type:</span> Forecast
          </div>
          <div>
            <span className="font-semibold">Start:</span> {startLabel}
          </div>
          <div>
            <span className="font-semibold">End:</span> {endLabel}
          </div>
        </div>
      </div>
      

      {showInsideLabels ? (
        <div className="absolute inset-0 flex items-center justify-between px-1 pointer-events-none">
          <span className="whitespace-nowrap text-black" style={labelStyle}>
            {startLabel}
          </span>
          <span className="whitespace-nowrap text-black" style={labelStyle}>
            {endLabel}
          </span>
        </div>
      ) : showOutsideRight ? (
        <div
          className="absolute top-1/2 left-[calc(100%+6px)] -translate-y-1/2 pointer-events-none text-black whitespace-nowrap"
          style={labelStyle}
        >
           {startLabel} to {endLabel}
        </div>
      ) : (
        <div
          className="absolute top-1/2 left-[calc(100%+6px)] -translate-y-1/2 whitespace-nowrap pointer-events-none text-black"
          style={labelStyle}
        >
          {startLabel} to {endLabel}
        </div>
      )}
    </div>
  );
}*/
import type { CSSProperties } from "react";
import { GanttWorkItem } from "../../types/gantt";
import { leftPx, widthPx } from "../../utils/ganttUtils";

/* Convert ISO date → DD/MM */
function formatDate(value: string) {
  const d = new Date(value);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}`;
}

export function ForecastBar({
  item,
  timelineStart,
  pxPerDay,
  timelineWidth,
}: {
  item: GanttWorkItem;
  timelineStart: Date;
  pxPerDay: number;
  timelineWidth: number;
}) {
  if (!item.forecast) return null;

  const start = new Date(item.forecast.start);
  const end = new Date(item.forecast.end);

  const left = leftPx(start, timelineStart, pxPerDay);
  const width = Math.max(widthPx(start, end, pxPerDay), 8);

  const startLabel = formatDate(item.forecast.start);
  const endLabel = formatDate(item.forecast.end);

  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  const durationDays =
    Math.ceil((end.getTime() - start.getTime()) / MS_PER_DAY) + 1;

  // gray start date - 45 days
  const grayMinus45 = new Date(start.getTime() - 45 * MS_PER_DAY);

  // actual end date < gray start date - 45 days
  const actualEnd = item.actual?.end ? new Date(item.actual.end) : null;
  const showOutsideRight = actualEnd ? actualEnd < grayMinus45 : false;

  // inside labels only when bar is long AND not the outside-right case
  const showInsideLabels = durationDays > 45 && !showOutsideRight;

  const isPositiveWorkId = item.workId > 0;

  const barClass = isPositiveWorkId
    ? "absolute top-[28px] h-3 border border-gray-700 border-dashed bg-gray-600 group z-30"
    : "absolute top-[28px] h-3 border border-gray-400 border-dashed bg-gray-400 group z-30";

  const insideLabelStyle: CSSProperties = {
    //fontFamily: "Segoe UI, sans-serif",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    color: "#FFFFFF",
    textShadow: "0 0 2px rgba(0,0,0,0.35)",
  };

  const outsideLabelStyle: CSSProperties = {
    //fontFamily: "Segoe UI, sans-serif",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    color: "#000000",
    textShadow: "0 0 2px white",
  };

  return (
    <div className={barClass} style={{ left, width }}>
      {/* ================= TOOLTIP ================= */}
      <div className="pointer-events-none absolute -top-14 left-1/2 -translate-x-1/2 z-50 hidden group-hover:block">
        <div className="rounded bg-gray-900 text-white text-xs px-3 py-2 shadow-lg whitespace-nowrap">
          <div>
            <span className="font-semibold">Work:</span> {item.workElement}
          </div>
          <div>
            <span className="font-semibold">Type:</span> Forecast
          </div>
          <div>
            <span className="font-semibold">Start:</span> {startLabel}
          </div>
          <div>
            <span className="font-semibold">End:</span> {endLabel}
          </div>
        </div>
      </div>
      {/* =========================================== */}

      {showInsideLabels ? (
        <div className="absolute inset-0 flex items-center justify-between px-1 pointer-events-none">
          <span className="whitespace-nowrap" style={insideLabelStyle}>
        
            {startLabel}
          </span>
         <span className="whitespace-nowrap" style={insideLabelStyle}>
        
            {endLabel}
          </span>
        </div>
      ) : showOutsideRight ? (
        <div
         className="absolute top-1/2 left-[calc(100%+6px)] -translate-y-1/2 pointer-events-none whitespace-nowrap"
        // className="gantt-text absolute top-1/2 left-[calc(100%+6px)] -translate-y-1/2 pointer-events-none whitespace-nowrap"
          style={outsideLabelStyle}
        >
          {startLabel} to {endLabel}
        </div>
      ) : (
        <div
          className="absolute top-1/2 left-[calc(100%+6px)] -translate-y-1/2 whitespace-nowrap pointer-events-none"
          //className="gantt-text absolute top-1/2 left-[calc(100%+6px)] -translate-y-1/2 pointer-events-none whitespace-nowrap"
          style={outsideLabelStyle}
        >
          {startLabel} to {endLabel}
        </div>
      )}
    </div>
  );
}